import React from "react";
import Grid from "../Grid/grid";
import Title from "../title";
import ContactForm from "../contact-form/contact-form";

function TechnologiesContact({
    contactRef,
}: {
    contactRef: React.RefObject<HTMLDivElement>;
}) {
    return (
        <section
            ref={contactRef}
            className="w-full min-h-screen h-full relative flex flex-col overflow-hidden p-2 lg:p-16"
        >
            <Grid size={100} direction="top-center" />
            <div className="z-10 flex justify-start items-start mb-12 w-full">
                <Title title="Get in touch" />
            </div>
            <div className="flex md:flex-row flex-col justify-center">
                <div className="flex flex-col items-start justify-center gap-5 md:w-1/2">
                    <h2 className="md:text-4xl text-xl font-medium max-w-4xl">
                        Not sure which stack fits your product?
                    </h2>
                    <p className="text-gray-500">
                        Tell us about your idea and our architects will recommend the ideal
                        combination of technologies — no jargon, just a clear path forward.
                    </p>
                </div>
                <div className="mt-5 flex items-center justify-center md:w-1/2">
                    <ContactForm
                        title="Talk To Our Architects"
                        purpose="Technology Consultation"
                    />
                </div>
            </div>
        </section>
    );
}

export default TechnologiesContact;
